import intersect from '../directives/intersect';
import scrollDirective from '../directives/scrollDirective';
// import other directives if you have more

// Define a function that registers all directives
export const registerDirectives = (app) => {
  app.directive('intersect', intersect);
  app.directive('scrollDirective', scrollDirective);
  // ... register other directives
};